import React from 'react'

const Copyright = () => {
  return (
    <div className="flex justify-center w-screen pb-1">
            <span className=" text-xs lg:font-normal  font-extralight font-gilroyy opacity-80">© Copyright Vyda Agency 2023.All Rights Rserved.</span>
    </div>
  )
}

export default Copyright;